
























































import Vue, { PropType } from 'vue';
import { Badge, SortListItem } from '../../types/FilterTypes';
import SortDropdown from './SortDropdown.vue';

interface IProps {
  filterTypeNearby: boolean;
  showBadge: boolean;
  badge: Badge;
  cityName: string;
}

export default Vue.extend({
  name: 'FilterButtons',
  components: {
    SortDropdown,
  },
  data() {
    return {
      isSortDropdownOpen: false,
    };
  },
  props: {
    showBadge: {
      type: Boolean as PropType<IProps['showBadge']>,
      required: true,
    },
    badge: {
      type: Object as PropType<IProps['badge']>,
      required: false,
    },
    cityName: {
      type: String as PropType<IProps['cityName']>,
      required: false,
    },
    filterTypeNearby: {
      type: Boolean as PropType<IProps['filterTypeNearby']>,
      default: false,
    },
    sortOptions: {
      type: Array as PropType<SortListItem[]>,
      default: [],
    },
    selectedSort: {
      type: String,
      default: '',
    },
  },
  methods: {
    triggerSuperDropdown(): void {
      // jQuery jank, because thats how SD works :D
      $('.super-dropdown-trigger').trigger('click.openDropdown');
    },
    handleSortClick() {
      this.isSortDropdownOpen = !this.isSortDropdownOpen;
    },
    handleSortChange(sortOption: SortListItem) {
      this.$emit('sort-change', sortOption);
      this.isSortDropdownOpen = false;
    },
    handleClickOutside(event: MouseEvent) {
      const sortingContainer = this.$el.querySelector('.sorting-container');
      if (sortingContainer && !sortingContainer.contains(event.target as Node)) {
        this.isSortDropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    hasCityName(): boolean {
      return this.cityName != null;
    },
    defaultSortingType(): string {
      if (this.filterTypeNearby) {
        return this.$t('35314.APIDealFilter_SortingDistance');
      }

      return this.$t('10017512.Home_RecommendedSort');
    },
  },
  watch: {
    // jQuery jank, because thats how SD works :D
    badge(newVal) {
      $('#navbar')
        .find('.filter-icon .badge')
        .toggleClass('hidden', newVal == null)
        .text(newVal && newVal.label ? newVal.label : '');
    },
    showBadge(newVal) {
      $('#navbar').find('.filter-icon .badge').toggleClass('hidden', !newVal);
    },
  },
});
